export default function SelectIconFill(props) {
  return (
    <svg
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill={props.fill || "#6CB6E3"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 8C0 3.5816 3.5816 0 8 0C12.4184 0 16 3.5816 16 8C16 12.4184 12.4184 16 8 16C3.5816 16 0 12.4184 0 8ZM10.9656 6.9656C11.1113 6.81472 11.192 6.61264 11.1901 6.40288C11.1883 6.19312 11.1042 5.99247 10.9559 5.84415C10.8075 5.69582 10.6069 5.61168 10.3971 5.60986C10.1874 5.60804 9.98528 5.68867 9.8344 5.8344L7.2 8.4688L6.1656 7.4344C6.01472 7.28867 5.81264 7.20804 5.60288 7.20986C5.39312 7.21168 5.19247 7.29582 5.04415 7.44415C4.89582 7.59247 4.81168 7.79312 4.80986 8.00288C4.80804 8.21264 4.88867 8.41472 5.0344 8.5656L6.6344 10.1656C6.78442 10.3156 6.98787 10.3998 7.2 10.3998C7.41213 10.3998 7.61558 10.3156 7.7656 10.1656L10.9656 6.9656Z"
      />
    </svg>
  )
}
